//import {$,jQuery} from 'jquery';
import './js/jquery.datetimepicker.full.min';

import "@fancyapps/ui/dist/fancybox/fancybox.css";
import './js/scripts.js';
import './scss/main.scss';